import classnames from "classnames";
import NavAnchor from "../../NavAnchor";
import { navigationItemPropType } from "../../../../state/modules/navigation";
import { getBackgroundImageUrl } from "../../../../helpers/navigationBackgroundImageResolver";
import LazyImage from "../../../LazyImage";

import styles from "./index.css";
import asosWorldLogo from "../../assets/asos-world-logo.svg";
import padlock from "./assets/padlock.svg";
import { getLoyaltyStatus } from "@template/state/modules/loyalty";
import { useSelector } from "react-redux";

const cx = classnames.bind(styles);

const CircleImageLeftItem = ({ item }) => {
  const { optedIn: isOptedInToLoyalty, isAvailable: isLoyaltyAvailable } =
    useSelector(getLoyaltyStatus);

  const { label, smallAndMediumImageUrl, smallAndMediumStyleType } = item;

  const asosWorldCategory = item.loyaltyBenefitType === "EarlyAccessToNewIn";

  return (
    <li className={styles.menuItem}>
      <NavAnchor className={styles.button} item={item}>
        <LazyImage
          aria-hidden="true"
          className={styles.circleImage}
          role="presentation"
          src={getBackgroundImageUrl(smallAndMediumImageUrl, 240)}
          tag={"div"}
          title={label}
        />
        {asosWorldCategory && isLoyaltyAvailable && !isOptedInToLoyalty && (
          <div className={styles.lockedContainer}>
            <img src={padlock} className={styles.padlock} alt="Lock icon" />
          </div>
        )}
        <span
          className={cx(styles.label, {
            [styles.label__sale]: smallAndMediumStyleType === "sale",
            [styles.label__bold]: smallAndMediumStyleType === "premium"
          })}
        >
          {asosWorldCategory && isLoyaltyAvailable && (
            <img src={asosWorldLogo} className={styles.logo} alt="ASOS World" />
          )}
          {label.substring(0, 40)}
        </span>
      </NavAnchor>
    </li>
  );
};

CircleImageLeftItem.propTypes = {
  item: navigationItemPropType.isRequired
};

export default CircleImageLeftItem;
